<template>
    <ARecordListEditor>
    </ARecordListEditor>
</template>

<script>
import ARecordListEditor from "../components/ARecordListEditor";

export default {
  name: "settings",
  components: { ARecordListEditor }
};
</script>